import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ContentMessage } from '@interfaces/content-message.model';
import { TranslateService } from '@ngx-translate/core';
import { CriticalParamsService } from '@services/critical-params/critical-params.service';
import { MessageCardAction } from '@interfaces/message-card-action.interface';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class ContentMessagingService {
  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private criticalParams: CriticalParamsService
  ) {}

  public getHomepageMessages(): Observable<ContentMessage[]> {
    const url = `/api/homepage_messages.json`;
    return this.criticalParams.getResolvedCriticalParams().pipe(
      switchMap((params: any) =>
        this.http
          .get(url, {
            params: params,
          })
          .pipe(
            catchError(() => of({})),
            map((result: any) => result?.homepage_messages || []),
            map((result: any[]) =>
              result.map((message) => this.mapContentMessage(message))
            )
          )
      )
    );
  }

  private mapContentMessage(message: ContentMessage): ContentMessage {
    message = new ContentMessage(message);
    message.actions = this.updateMessageActions(message);
    return message;
  }

  private updateMessageActions(message: ContentMessage): MessageCardAction[] {
    if (!message.link) {
      return [];
    }

    return [
      {
        title:
          message.button_text ||
          this.translate.instant('homepage_content_messaging_action_button'),
        url: message.link,
        newTab: !message.internal_link,
      },
    ];
  }
}
